import PayTransfer from 'components/pay';
import React from 'react';

const PayPage = () => {
  return (
    <div className="leftContent">
      <PayTransfer />
    </div>
  );
};

export default PayPage;
